import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SetSuppliersRequest } from 'app/generated/backend/shipment/api/set-suppliers-request';
import { SetSuppliersResponse } from 'app/generated/backend/shipment/api/set-suppliers-response';

@Injectable()
export class SetSuppliersHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		request: SetSuppliersRequest
	): Observable<JsonResourceResponse<SetSuppliersResponse>> {
		return this.http.post<JsonResourceResponse<SetSuppliersResponse>>('api/v1/shipment/setSuppliers', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		SetSuppliersHandlerService
	]
})
export class SetSuppliersHandlerModule { }
